(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pymes-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var galeria = document.querySelector('[data-pymes-gallery]');
  if (galeria) {
    var principal = galeria.querySelector('#PymesMainImage');
    galeria.querySelectorAll('.pymes-thumb').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!principal) return;
        principal.srcset = '';
        principal.src = b.dataset.src;
        galeria.querySelectorAll('.pymes-thumb').forEach(function (o) {
          o.classList.remove('is-on');
        });
        b.classList.add('is-on');
      });
    });
  }

  var barra = document.querySelector('[data-pymes-sticky]');
  var boton = document.querySelector('[data-pymes-buy]');
  if (barra && boton && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      var fuera = !entradas[0].isIntersecting;
      barra.classList.toggle('is-on', fuera);
      barra.setAttribute('aria-hidden', fuera ? 'false' : 'true');
    }, { rootMargin: '0px 0px -40px 0px' }).observe(boton);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
